import React, { useState, useEffect } from 'react';
import { MdHomeFilled } from "react-icons/md";
import { IoSearch } from "react-icons/io5";
import LogoImage from '../../components/images/logo.png';
import { Link, useParams } from 'react-router-dom';
import Menu from "./components/menu/index.js";

import * as C from './styles.js'

function Header({ user, hidden, backgroundNav, loadingUser, profile }) {
  const [isOpen, setIsOpen] = useState(false);
  const [scrolled, setScrolled] = useState(false);

  const [ showModal, setShowModal ] = useState(false);
  const [ dispositivoUsuario, setDispositivoUsuario ] = useState(false);

  const { movieType } = useParams();

  useEffect(() => {
    const handleScroll = () => {
      const offset = window.scrollY;
      if (offset > 0) {
        //document.querySelector('meta[name="theme-color"]').setAttribute('content', '#303030')
        setScrolled(true);
      } else {
        setScrolled(false);
        //document.querySelector('meta[name="theme-color"]').setAttribute('content', '#202020')
      }
    };

    window.addEventListener('scroll', handleScroll);
    return () => {
      window.removeEventListener('scroll', handleScroll);
    };
  }, []);

  useEffect(()=> {
        
    const larguraTela = window.screen.width;
    if (larguraTela > 800) {
        setDispositivoUsuario("pc");
    } else if (larguraTela < 800) {
        setDispositivoUsuario("mobile");
    }
    
}, []);

  if (loadingUser) return null;

  return (
    <C.Container id="content-nav" hidden={hidden} className={scrolled ? 'scrolled' : ''} background_color={(movieType == 'tv' || movieType == 'movie') ? backgroundNav : null}>
      <C.ContainerMenu>
        <Link to="/" className="logo-desktop">
          <C.Logo to='/'>
            <img src={LogoImage} alt={"Logo do Moov"} loading="lazy" />
            <span className='span-pro'>PRO</span>
          </C.Logo>
        </Link>
        {user?.uid &&
          <C.Menu className="nav">
            <Link to='/'>
              <i className="fa-solid fa-house-crack"></i>
              <span className="span-link-nav">Início</span>
            </Link>
            <Link to='/canais'>
              <i class="fa-solid fa-tower-broadcast"></i>
              <span className="span-link-nav">Canais</span>
            </Link>
            {/*<Link to='/pesquisar/movie'>
              <i className="fa-solid fa-clapperboard"></i>
              <span className="span-link-nav">Filmes</span>
            </Link>
            <Link to='/pesquisar/tv'>
              <i className="fa-solid fa-tv"></i>
              <span className="span-link-nav">Séries</span>
            </Link>*/}
          </C.Menu>
        }
      </C.ContainerMenu>
      {user?.uid &&
        <C.Menu>
          <div className="logo-mobile">
            <Link to="/">
              <C.Logo to='/'>
                <img src={LogoImage} alt={"Logo do Moov"} loading="lazy" />
                <span className='span-pro'>PRO</span>
              </C.Logo>
            </Link>
          </div>
          <div>
            <Link to={`/pesquisar/`} className='search-link'>
                <i className="fas fa-search"></i>
            </Link>
            <button className="container-profile" onClick={()=>(user.uid && profile && profile?.profile_uid) && setShowModal(!showModal)} onMouseEnter={()=>(user.uid && profile && profile?.profile_uid && (dispositivoUsuario == 'pc')) && setShowModal(true)} onMouseLeave={()=>setShowModal(false)}>
              <img className="profile-img" src={profile?.profile_photo_url} alt='usuario' onError={({ currentTarget }) => {currentTarget.onerror = null; currentTarget.src="https://dflix.netlify.app/imagens/img-avatar.png";}}/>
            </button>
          </div>
        </C.Menu>
      }

      <Menu profile={profile} showModal={showModal} setShowModal={setShowModal}/>

    </C.Container>
  );
}

export default Header;
